"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../mantine-hooks/src");
var Input_1 = require("../Input/Input");
var InputWrapper_1 = require("../InputWrapper/InputWrapper");
function TextInput(_a) {
    var className = _a.className, id = _a.id, label = _a.label, error = _a.error, required = _a.required, _b = _a.type, type = _b === void 0 ? 'text' : _b, style = _a.style, icon = _a.icon, description = _a.description, themeOverride = _a.themeOverride, wrapperProps = _a.wrapperProps, elementRef = _a.elementRef, others = __rest(_a, ["className", "id", "label", "error", "required", "type", "style", "icon", "description", "themeOverride", "wrapperProps", "elementRef"]);
    var uuid = hooks_1.useId(id);
    return (react_1.default.createElement(InputWrapper_1.InputWrapper, __assign({ required: required, id: uuid, label: label, error: error, description: description, className: className, style: style, themeOverride: themeOverride }, wrapperProps),
        react_1.default.createElement(Input_1.Input, __assign({}, others, { required: required, elementRef: elementRef, id: uuid, type: type, invalid: !!error, icon: icon, themeOverride: themeOverride }))));
}
exports.TextInput = TextInput;
TextInput.displayName = '@mantine/core/TextInput';
